import { gql } from "@apollo/client";

  export const UPDATE_LEAD_STATUS = gql`
  mutation UpdateLeadStatus($updateleadstatus: UpdateLeadStatus!){
    updateLeadStatus(updateleadstatus : $updateleadstatus,api_called_by:"web") {
      message
    }
  }`